import * as types from './types'
import http from '../../utils/http'
import Vue from 'vue'

const vue = new Vue()

const state = {
  billList: [], // 首页账单列表
  billInfoList: [], // 账单详情数据
  costList: {},
  groupCost: {},
  total: 0,
  isLock: false,
  cancelBill: false,
  payCost: false,
  schedulingLogList: {}
}

// 获取接口数据集合
const actions = {
  [types.GETALLBILL] (context, params) { // 获取账单列表
    http.fetch('/api/bill/getAllBill', params).then(data => {
      context.commit(types.GETALLBILL, data)
    })
  },
  [types.REMOVELOCKBILL] (context, params) { // 解锁
    http.fetch('/api/bill/removeLockBill', params).then(data => {
      context.commit(types.REMOVELOCKBILL, data)
    })
  },
  [types.CANCELBILL] (context, params) { // 取消账单
    http.fetch('/api/bill/cancelBill', params).then(data => {
      context.commit(types.CANCELBILL, data)
    })
  },
  [types.GETGROUPCOST] (context, params) { // 获取费用统计列表
    http.fetch('/api/bill/getGroupCost', params).then(data => {
      context.commit(types.GETGROUPCOST, data)
    })
  },
  [types.OFFLINEPAY] (context, params) { // 线下支付
    http.fetch('/api/bill/offlinePay', params).then(data => {
      context.commit(types.OFFLINEPAY, data)
    })
  },
  [types.GETBILLDETAIL] (context, params) { // 获取账单详情
    http.fetch('/api/bill/getBillDetail', params).then(data => {
      context.commit(types.GETBILLDETAIL, data)
    })
  },
  [types.LOCKBILL] (context, params) { // 锁定账单
    http.fetch('/api/bill/lockBill', params).then(data => {
      context.commit(types.LOCKBILL, data)
    })
  },
  [types.BILLTASKPAGE] (context, params) { // 时间调度
    http.fetch('/api/schedulerTask/billTaskPage', params).then(data => {
      context.commit(types.BILLTASKPAGE, data)
    })
  },
  [types.MONITORJOB] (context, params) {
    return new Promise((resolve, reject) => {
      http.fetch('bill/monitorJob', params).then(data => {
        context.commit(types.MONITORJOB, data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.GETALLBILL] (state, data) {
    state.billList = data.obj.records
    state.total = data.obj.total
    console.log(data, '查询数据')
  },

  [types.CANCELBILL] (state, data) {
    if (data.code !== 200) return false
    vue.$message({
      showClose: true,
      message: '取消账单成功',
      type: 'success'
    })
    console.log(data, '取消账单')
    state.cancelBill = data.success + Math.random()
  },
  [types.GETBILLDETAIL] (state, data) {
    state.billInfoList = data.obj.ycBill
    state.costList = data.obj
    console.log(data, '账单详情')
  },
  [types.GETGROUPCOST] (state, data) {
    state.groupCost = data
    console.log(data, '费用统计')
  },
  [types.OFFLINEPAY] (state, data) {
    // state.groupCost = data
    // console.log(data, '线下支付')
    if (data.code !== 200) return false
    vue.$message({
      showClose: true,
      message: '线下支付成功',
      type: 'success'
    })
    console.log(data, '线下支付')
    state.payCost = data.success + Math.random()
  },
  [types.REMOVELOCKBILL] (state, data) {
    if (data.code !== 200) return false
    vue.$message({
      showClose: true,
      message: '解锁成功',
      type: 'success'
    })
    state.isLock = data.success + Math.random()
  },
  [types.BILLTASKPAGE] (state, data) {
    state.schedulingLogList = {
      rows: data.obj.records,
      total: data.total
    }
  }

}
export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/billManage/index.js